<template>
  <div>
    <Title v-if="!isAdmin" :showMinister="true" :showService="true" />
    <Breadcrumb :links="breadCrumbData" />
    <Carrusel />

    <h3 class="text-indicator">Organigrama de Servicio</h3>
    <div class="container">
      <Help :title="title" :text="text" :uno="uno" :dos="dos" />
    </div>

    <div><Main /></div>
  </div>
</template>

<script>
import Title from "../../../components/private/Title";
import Breadcrumb from "@/components/tools/Breadcrumb.vue";
import Carrusel from "../../../components/private/Carrusel.vue";
import Help from "../../../components/tools/Modal.vue";
//import Button from "./main/Button.vue";
import Main from "./main/Main";
import { mapState } from "vuex";

export default {
  components: {
    Title,
    Breadcrumb,
    Carrusel,
    //Button,
    Main,
    Help,
  },
  data() {
    return {
      permission: true,
      breadCrumbData: null,
      image: null,
      title: "Organigrama de Servicio",
      text:
        "Para completar el servicio por favor seguir las siguientes instrucciones",
      uno: "Se permite formato PNG, SVG, y JPG",
      dos: "Tamaño de la imagen max: 2mb",
    };
  },
  computed: {
    ...mapState("sesion", ["usuario"]),
    isAdmin: function() {
      return this.usuario.username === process.env.VUE_APP_USER_ADMIN;
    },
  },
  methods: {
    setBreadcrumbData: function() {
      this.breadCrumbData = [
        {
          name: "Portada BGI",
          routeName: "bgi",
          routeParams: {
            idUsuario: this.usuario.id,
          },
        },
        {
          name: "Escritorio de Gestión Virtual",
          routeName: "buttons",
          routeParams: {
            idUsuario: this.usuario.id,
            idServicio: this.$route.params.idServicio,
          },
        },
        {
          name: "Organigrama de Servicio",
          routeName: "oservicio",
          routeParams: {
            idServicio: this.$route.params.idServicio,
          },
        },
      ];
    },
  },
  mounted() {
    this.setBreadcrumbData();
  },
};
</script>

<style scoped>
.text-indicator {
  text-align: center;
}
</style>
